import './style_preset_hint_box.less';

import React from 'react';

const INLINE_TRANSPARENCY_SVG = `
<svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
  <defs> 
    <pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse">
      <rect fill="black" x="0" y="0" width="10" height="10" opacity="0.1"/>
      <rect fill="white" x="10" y="0" width="10" height="10"/>
      <rect fill="black" x="10" y="10" width="10" height="10" opacity="0.1"/>
      <rect fill="white" x="0" y="10" width="10" height="10"/>
    </pattern>
  </defs>
  <rect fill="url(#grid)" x="0" y="0" width="100%" height="100%"/>
</svg>`;

const INLINE_TRANSPARENCY_SVG_URL = `url('data:image/svg+xml;utf8,${INLINE_TRANSPARENCY_SVG.replace('#','%23')}')`;

const StylePresetHintBox = ({ 
  style, 
  tilebg, 
  tileborder, 
  pcolor, 
  pweight,
  pstyle, 
  h1color,
  h1weight,
  h1style
})=> (
  <div 
    className="style-preset-hint-box"
    style={{
      border: tileborder || '1px dashed #AAA',
      ...(tilebg ? { background: tilebg } : { backgroundImage: INLINE_TRANSPARENCY_SVG_URL }),
      ...style
    }}
  >
    <span
      className="elem-example"
      style={{
        color: pcolor,
        fontWeight: pweight,
        fontStyle: pstyle
      }}
    >
      P
    </span>

    <span
      className="elem-example"
      style={{
        color: h1color,
        fontWeight: h1weight,
        fontStyle: h1style
      }}
    >
      H1
    </span>
  </div>
);

export default StylePresetHintBox;
